export default {
  id : 'boat.globalstar.sensor.itemCreateHook',
  matches : {
    objectType : 'globalstar',
    path : 'boat.globalstar',
  },
  hook : async ( device ) => {
    const mobileIdObj = device.data.find( item => item.path === 'mobileId' )
    const mobileId = mobileIdObj.value

    const newName = `Siren Marine Globalstar ${mobileId}`
    // eslint-disable-next-line no-param-reassign
    device.name = newName

    return device
  }
}
